// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_6d-2";
export var blackBorderOnHover = "_6d-7";
export var cell = "_6d-6";
export var cellContainer = "_6d-3";
export var checked = "_6d-8";
export var disabled = "_6d-5";
export var featuredIconCellContainer = "_6d-9";
export var featuredIconTextContainer = "_6d-b";
export var featuredIconWrapper = "_6d-a";
export var noBorder = "_6d-c";
export var orangeSelectedRow = "_ce-3";
export var overflowableText = "_6d-0";
export var overflowableTextContainer = "_6d-1";
export var row = "_6f-0";
export var rowCheckboxCell = "_6d-4";
export var selectableTable = "_ce-2";